import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'

import DataTableStore from './DataTableStore'
import Pagination from './Pagination'
import { sortBy } from '../../utils/helpers'

import './data-table.scss'

@observer
class DataTable extends Component {
    constructor(props) {
        super(props)
        const { dataSet, store, loadRecords } = props
        this.dataTableStore = new DataTableStore(dataSet ? dataSet.length : 0, loadRecords)
        this.dataRows = dataSet || store?.filteredList || []

        this.state = {
            sortDesc: R.pathOr(-1, ['sortDesc'], props),
            sorting: R.pathOr(false, ['sorting'], props),
            sortKey: R.pathOr(undefined, ['sortKey'], props),
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { dataSet } = this.props
        const { sorting, sortDesc, sortKey } = this.state

        if ((!nextProps.dataSet || nextProps.dataSet.length < 1) && dataSet?.length < 1) {
            this.dataRows = []
            return
        }

        if (nextProps.recordCount && this.dataTableStore.dataLength !== nextProps.recordCount) {
            this.dataTableStore.updateDataLength(nextProps.recordCount)
        } else if (!nextProps.recordCount) {
            this.dataTableStore.updateDataLength(nextProps.dataSet.length)
        }

        if (sorting === true) {
            this.dataRows = sortBy(nextProps.dataSet || nextProps.store.filteredList, sortKey, sortDesc)
        } else {
            this.dataRows = nextProps.dataSet || nextProps.store.filteredList
        }
    }

    setSortColumn = (key) => {
        const { inMemory } = this.props
        const { sortDesc, sorting } = this.state
        if (!inMemory) return

        if (sortDesc === -1 && sorting) {
            this.setOriginalSorting()
            return
        }

        this.dataRows = sortBy(this.dataRows, key, sortDesc / -1)
        this.setState({ sortDesc: sortDesc / -1, sorting: true, sortKey: key })
    }

    sortIcon = (key) => {
        const { sorting, sortDesc, sortKey } = this.state
        if (!sorting) return null

        if (key !== sortKey) return null

        return sortDesc === 1 ? <i className="fa-regular fa-arrow-up" /> : <i className="fa-regular fa-arrow-down" />
    }

    setOriginalSorting = () => {
        const { dataSet } = this.props
        this.setState({ sorting: false, sortKey: undefined })
        this.dataRows = dataSet
    }

    renderRows = () => {
        const {
            columns, rowClick, rowId, inMemory,
        } = this.props
        const { dataTableStore } = this
        return (
            this.dataRows.map((row, i) => (
                (!inMemory
                    || (inMemory && i <= dataTableStore.maxRecord && i >= dataTableStore.minRecord))
                    ? (
                        <tr key={`datatable_tr_${i}`} onClick={(e) => (rowClick ? rowClick(e, row[rowId]) : null)}>
                            {
                                columns.map((column) => (
                                    <td
                                        className={`gridcell ${column.cellClass ? column.cellClass : ''}`}
                                        onClick={(e) => (column.columnClick ? column.columnClick(e, row[column.key], row) : null)}
                                    >
                                        {
                                            column.dataTransform
                                                ? column.dataTransform(row[column.key], row)
                                                : row[column.key]
                                        }
                                    </td>
                                ))
                            }
                        </tr>
                    ) : null
            ))
        )
    }

    renderTable = () => {
        const { columns, inMemory } = this.props

        return (
            <table>
                <thead>
                    <tr>
                        {
                            columns.map((column, i) => (
                                <th
                                    key={`datatable_th_${i}`}
                                    onClick={() => (inMemory ? this.setSortColumn(column.key) : null)}
                                    className={`sortable ${column.headerClass ? column.headerClass : ''}`}
                                >
                                    {column.name}
                                    {this.sortIcon(column.key)}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {this.renderRows()}
                </tbody>
            </table>
        )
    }

    render() {
        const {
            inMemory, dataSet, cssClass, showPagination,
        } = this.props
        return (
            <div id="dataTable" className={cssClass}>
                <div className="tableContainer">
                    {this.renderTable()}
                </div>
                {dataSet?.length > 0 && (inMemory || showPagination)
                    && (
                        <Pagination
                            {...this.props}
                            dataTableStore={this.dataTableStore}
                        />
                    )}
                {(dataSet?.length === 0) && (
                    <div className="table-empty">{i18n.t('datatable.noRecords', 'No records at the moment')}</div>
                )}
            </div>
        )
    }
}

export default DataTable
